<template>
  <div class="flex-wrap text-medium-semibold uppercase" v-if="internalComment">
    {{ internalComment }}
  </div>
</template>

<script lang="ts" setup>
  import type { GraphQLCarDetail } from '~/types/graphql';

  const carDetail = inject<GraphQLCarDetail>('carDetail');

  const internalComment = computed(() => {
    if (!carDetail?.internal_comment) return '';

    let comment = carDetail.internal_comment;
    if (comment.startsWith('*')) {
      comment = comment.slice(1);
    }

    if (comment.endsWith('*')) {
      comment = comment.slice(0, -1);
    }

    return comment;
  });
</script>

<style lang="scss" scoped></style>
